import { CEREBRUMX_NAMES } from '../utils/rawDataAccess';
import { cerebrumxAdapter } from './cerebrumx/adapter';

/** One entry per manufacturer name the platform serves; names are matched case-insensitively. */
const ADAPTERS = Object.fromEntries(CEREBRUMX_NAMES.map((name) => [name, cerebrumxAdapter]));

/** The manufacturer's presentation of a raw payload, or null (the modal then shows the JSON view). */
export const getRawDataAdapter = (manufacturerName) => {
	if (typeof manufacturerName !== 'string') return null;
	return ADAPTERS[manufacturerName.trim().toUpperCase()] ?? null;
};
